import { useEffect } from 'react';

// use this hook to disbale broswer changing page accidentally due to over scroll
function useDisableScrollBrowserNav() {
    useEffect(() => {
        if (document.querySelector("body") !== null) {
            document.querySelector("body").style.overscrollBehaviorX = "none";
        }
    }, []);
}

export { useDisableScrollBrowserNav };
//# sourceMappingURL=useDisableScrollBrowserNav.js.map
